var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-center",attrs:{"to":_vm.to,"color":_vm.color}},[_c('v-card-text',{attrs:{"align":""}},[_c('v-icon',{attrs:{"size":"55"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('v-card-title',{staticClass:"pt-0 justify-center",style:(`font-size: ${_vm.fontSize}`)},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }